// index.tsx（または index.js）
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import ConstList from "./utils/ConstList";
import { RecoilRoot } from "recoil";
import Routers from "./Pages/Routers";
import { MediaQueryProvider } from "./component/MediaQueryProvider";
import Header from "./Pages/Header";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";

// LicenseInfo.setLicenseKey(
//   "21fbb7846f7fa8f67cf1b67ec02ac53fTz0xMTAyOTEsRT0xNzc0NTY5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
// );
// サイトタイトルや言語の設定はそのまま
document.title = ConstList.SYS_TITLE;
document.documentElement.lang = "ja";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <Auth0Provider
    domain={ConstList.DOMAIN}
    clientId={ConstList.CLIENT_ID}
    redirectUri={ConstList.REDIRECT_URL}
    audience={ConstList.AUDIENCE}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RecoilRoot>
        <MediaQueryProvider>
        <Routers />
        </MediaQueryProvider>
      </RecoilRoot>
    </ThemeProvider>
  </Auth0Provider>,
);

reportWebVitals();
